import { useUserProvider } from "./provider";
import { Button, HStack, Text } from "@chakra-ui/react";
import "./index.css";
import { Link } from "react-router";
import useProfile from "../../hooks/data/useProfile";
import { TextEditable, Tooltip } from "../reusables";
import { FiCheck } from "react-icons/fi";
/**
 *
 * @param {import("@chakra-ui/react").ButtonProps & import("./props").UserProps} props
 * @returns
 */
const FollowButton = (props) => {
  const user = useUserProvider();
  const { followProfile, unfollowProfile } = useProfile();

  function performFollow() {
    if (user?.isFollowedByUser) {
      unfollowProfile({
        username: user.username,
      });
    } else {
      followProfile({
        username: user.username,
      });
    }
  }

  return (
    <Tooltip
      label={user?.isFollowedByUser && "Click to unfollow"}
      placement="bottom"
    >
      <Button
        borderRadius={"full"}
        size="sm"
        fontSize={"xs"}
        onClick={performFollow}
        gap="0"
        px={!user.isFollowedByUser ? "6" : "3"}
        bg={user?.isFollowedByUser ? "green.300" : "white"}
        leftIcon={
          user?.isFollowedByUser && <FiCheck size={14} fontWeight={"bold"} />
        }
        {...props}
      >
        {user?.isFollowedByUser ? "Following" : "Follow"}
      </Button>
    </Tooltip>
  );
};

export default FollowButton;
